import { render } from "./SavedPages.vue?vue&type=template&id=665d1f08&scoped=true"
const script = {}

import "./SavedPages.vue?vue&type=style&index=0&id=665d1f08&scoped=true&lang=css"

import exportComponent from "/home/mitch/frontend/demoenv/demo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-665d1f08"]])

export default __exports__